import { API } from '../Api';

// Trang sản phẩm CÔNG KHAI cho link tiếp thị — xem được khi chưa đăng nhập.
export interface PublicProduct {
  id: string;
  title: string;
  category: string;
  rarity: string | null;
  priceCa: number;
  /** Trang mua thật — chỉ đưa tới sau khi đăng nhập. */
  buyPath: string;
  isActive: boolean;
}

export const getPublicProduct = (productId: string) =>
  API.get<PublicProduct>(
    `/v1/payment-service/public/affiliate/product/${productId}`
  ).then((r) => r.data);

// Vài sản phẩm khác — phần giới thiệu thêm ở cuối trang.
export const getPublicProducts = (excludeId?: string, take = 6) =>
  API.get<PublicProduct[]>('/v1/payment-service/public/affiliate/products', {
    params: { excludeId, take },
  }).then((r) => r.data);

